import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "profile-creation-wizard__side" }
const _hoisted_2 = { class: "profile-creation-wizard__side-mobile" }
const _hoisted_3 = ["close-label"]
const _hoisted_4 = { slot: "bottom-sheet-content" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { class: "profile-creation-wizard__side-desktop" }
const _hoisted_7 = { class: "profile-creation-wizard__side-description" }
const _hoisted_8 = { class: "profile-creation-wizard__side-iconTitle" }
const _hoisted_9 = ["innerHTML"]

import {eventBusProfileCreationWizard} from '@/profile-creation-wizard/common/events';
    import {getTipsClassPosition} from '@/common/ui/GetTipsClassPosition';
    import {useTranslation} from '@malt/vue3-use';
    import {computed, onBeforeUnmount, onMounted, ref} from 'vue';

    enum FocusElement {
        description,
    }

    
export default /*@__PURE__*/_defineComponent({
  __name: 'DescriptionSide',
  setup(__props) {

    const {msg} = useTranslation();

    const isDescriptionFocus = computed(() => focus.value === FocusElement.description);

    const tipsClassPosition = getTipsClassPosition(345);
    const focus = ref<FocusElement>(FocusElement.description);

    onMounted(() => {
        eventBusProfileCreationWizard.on('wizard:description-focus', handleDescriptionFocus);
    });

    onBeforeUnmount(() => {
        eventBusProfileCreationWizard.off('wizard:description-focus', handleDescriptionFocus);
    });

    function handleDescriptionFocus(): void {
        focus.value = FocusElement.description;
    }

return (_ctx: any,_cache: any) => {
  const _component_VJoyIcon = _resolveComponent("VJoyIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("joy-bottom-sheet", {
        id: "completion-description-bottom-sheet",
        "close-label": _unref(msg)('general.close')
      }, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("p", null, [
            _createElementVNode("strong", null, _toDisplayString(_unref(msg)('profile.creation.completion.wizard.v2.side.description.title')), 1)
          ]),
          _createElementVNode("p", {
            innerHTML: _ctx.$msg('profile.creation.completion.wizard.v2.side.description.content')
          }, null, 8, _hoisted_5)
        ])
      ], 8, _hoisted_3)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", {
        class: _normalizeClass(["profile-creation-wizard__side-container", {'no-focus': !isDescriptionFocus.value}]),
        style: _normalizeStyle(_unref(tipsClassPosition))
      }, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_VJoyIcon, {
              name: "freelancer-placeholder",
              size: "small"
            }),
            _createElementVNode("strong", null, _toDisplayString(_unref(msg)('profile.creation.completion.wizard.v2.side.description.title')), 1)
          ]),
          _createElementVNode("p", {
            innerHTML: _ctx.$msg('profile.creation.completion.wizard.v2.side.description.content')
          }, null, 8, _hoisted_9)
        ])
      ], 6)
    ])
  ]))
}
}

})